import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import getFormatMessage from '../../../../locales/get-format-message';

export const CreateNoticeNav = (props: { currentTitle?: string }) => {
  return (
    <Breadcrumb>
      <Breadcrumb.Item>{getFormatMessage('business_notice')}</Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to="/admin/notice/list">{getFormatMessage('notice_title')}</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        {props.currentTitle || getFormatMessage('notice_new')}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
};
